import { setCookie, getCookie, deleteCookie } from '../../../../../common/common/assets/src/js/cookies'
import { generate_guid } from '../../../../../common/common/assets/src/js/guid'
import * as ajax from '../../../../../common/common/assets/src/js/fetch'

(function() {
	'use strict'

	let cookie_settings = getCookie( liquidgumbo_cookies.settings_cookie )

	if (cookie_settings != null) {
		cookie_settings = JSON.parse(cookie_settings)
	}

	/* Wait for ready document because of Wordpress inline scripts needed */
	document.addEventListener( 'DOMContentLoaded', (ev) => {
		checkCookieButtons()
    })

	/* Handle click on allow all and deny all buttons */
	document.querySelector( 'a[href="#allow-all-cookies"]' )?.addEventListener( 'click', (ev) => {
		ev.preventDefault()

		/* Add classes */
		ev.target.classList.add( 'loading' )

		/* Setup */
		let params = {
				action: 'liquidgumbo_load_cookies',
				_ajax_nonce: liquidgumbo.security
			},
			options = {
				body: params
			},
			cookie_settings = {
				last_change: new Date().getTime()
			},
			settings_lifetime = '1y'

		ajax.post(
			liquidgumbo.ajaxurl,
			options
		).then((content) => {
			/* Check for cookies */
			if ( content.success == true ) {
				/* Check for cookies */
				if ( content.data.cookies ) {
					/* Switch type */
					for ( let key in content.data.cookies ) {
						if (content.data.cookies.hasOwnProperty( key ) ) {
							let cookie = content.data.cookies[key],
								lifetime = formatLifetime( cookie )

							/* Add cookie to cookie settings info */
							if ( cookie.cookiecategory != undefined ) {
								/* Add key as category to prevent name change problems */
								if ( cookie_settings[ cookie.cookiecategory.ID ] == undefined ) {
									cookie_settings[ cookie.cookiecategory.ID ] = {}
								}
								cookie_settings[ cookie.cookiecategory.ID ][ cookie.cookie_name ] = true
							} else {
								/* Add to undefined */
								if ( cookie_settings[ 'undefined' ] == undefined ) {
									cookie_settings[ 'undefined' ] = {}
								}
								cookie_settings[ 'undefined' ][ cookie.cookie_name ] = true
							}
							if ( cookie.cookie_name == content.data.config.settings_cookie ) {
								/* Safe settings lifetime */
								settings_lifetime = lifetime
							}

							/* Check for set the cookie */
							activateCookie( cookie, lifetime )
						}
					}
				}

				/* Set cookie */
				if ( content.data.config.settings_cookie != undefined ) {
					setCookie( content.data.config.settings_cookie, JSON.stringify(cookie_settings), settings_lifetime )
				}
			}

			/* Remove classes */
			ev.target.classList.remove( 'loading' )
			checkCookieButtons()
		})
		.catch((error) => {
			console.log(error)

			/* Remove classes */
			ev.target.classList.remove( 'loading' )
		})
	})
	document.querySelector( 'a[href="#deny-all-cookies"]' )?.addEventListener( 'click', (ev) => {
		/* Prevent */
		ev.preventDefault()

		/* Add classes */
		ev.target.classList.add( 'loading' )
		
		/* Setup */
		let params = {
				action: 'liquidgumbo_load_cookies',
				_ajax_nonce: liquidgumbo.security
			},
			options = {
				body: params
			},
			cookie_settings = {
				last_change : new Date().getTime()
			},
			settings_lifetime = '1y'
		
		/* Delete cookie settings cookie */
		ajax.post(
			liquidgumbo.ajaxurl,
			options
		).then((content) => {
			/* Check for cookies */
			if ( content.success == true ) {
				/* Check for cookies */
				if ( content.data.cookies ) {
					/* Switch type */
					for ( let key in content.data.cookies ) {
						if (content.data.cookies.hasOwnProperty( key ) ) {
							let cookie = content.data.cookies[key],
								lifetime = formatLifetime( cookie )

							/* Add cookie to cookie settings info - only for non-settings cookies */
							if ( cookie.cookiecategory != undefined ) {
								/* Add key as category to prevent name change problems */
								if ( cookie_settings[ cookie.cookiecategory.ID ] == undefined ) {
									cookie_settings[ cookie.cookiecategory.ID ] = {}
								}
								
								/* Check for deniable cookies */
								if ( cookie.cookiecategory.deniable == 1 ) {
									cookie_settings[ cookie.cookiecategory.ID ][ cookie.cookie_name ] = false
									deleteCookie( cookie.cookie_name )
								} else {
									cookie_settings[ cookie.cookiecategory.ID ][ cookie.cookie_name ] = true
								}
							} else {
								/* Add to undefined */
								if ( cookie_settings[ 'undefined' ] == undefined ) {
									cookie_settings[ 'undefined' ] = {}
								}
								cookie_settings[ 'undefined' ][ cookie.cookie_name ] = false
								deleteCookie( cookie.cookie_name )
							}
							if ( cookie.cookie_name == content.data.config.settings_cookie ) {
								/* Safe settings lifetime */
								settings_lifetime = lifetime
							}
						}
					}
				}

				/* Set cookie */
				if ( content.data.config.settings_cookie != undefined ) {
					setCookie( content.data.config.settings_cookie, JSON.stringify(cookie_settings), settings_lifetime )
				}
			}

			/* Remove classes */
			ev.target.classList.remove( 'loading' )
			checkCookieButtons()
		})
		.catch((error) => {
			/* Remove classes */
			ev.target.classList.remove( 'loading' )

			console.log(error)
		})
	})
	document.querySelector( 'a[href="#toggle-cookiebanner"]' )?.addEventListener( 'click', (ev) => {
		/* Prevent */
		ev.preventDefault()

		/* Toggle cookiebanner visibility */
		ev.target.closest( '.liquidgumbo-cookiebanner' ).classList.toggle( 'is-closed' )
	})
	document.querySelector( 'a[href="#allow-cookie"]' )?.addEventListener( 'click', (ev) => {
		/* Prevent */
		ev.preventDefault()

		/* Add classes */
		ev.target.classList.add( 'loading' )

		/* Setup */
		let params = {
				action: 'liquidgumbo_load_cookies',
				_ajax_nonce: liquidgumbo.security,
				cookie_name: ev.target.closest( '.cookie-item' ).getAttribute('data-cookie-name')
			},
			options = {
				body: params
			},
			cookie_settings = JSON.parse( getCookie( liquidgumbo_cookies.settings_cookie ) ),
			settings_lifetime = '1y'

		/* Set last date */
		cookie_settings['last_change'] = new Date().getTime()

		/* Delete cookie settings cookie */
		ajax.post(
			liquidgumbo.ajaxurl,
			options
		).then((content) => {
			/* Check for cookies */
			if ( content.success == true ) {
				/* Check for cookies */
				if ( content.data.cookies ) {
					/* Switch type */
					for ( let key in content.data.cookies ) {
						if (content.data.cookies.hasOwnProperty( key ) ) {
							let cookie = content.data.cookies[key],
								lifetime = formatLifetime( cookie )

							/* Add cookie to cookie settings info */
							if ( cookie.cookiecategory != undefined ) {
								/* Add key as category to prevent name change problems */
								if ( cookie_settings[ cookie.cookiecategory.ID ] == undefined ) {
									cookie_settings[ cookie.cookiecategory.ID ] = {}
								}
								cookie_settings[ cookie.cookiecategory.ID ][ cookie.cookie_name ] = true
							} else {
								/* Add to undefined */
								if ( cookie_settings[ 'undefined' ] == undefined ) {
									cookie_settings[ 'undefined' ] = {}
								}
								cookie_settings[ 'undefined' ][ cookie.cookie_name ] = true
							}

							/* Check for set the cookie */
							activateCookie( cookie, lifetime )
						}
					}

					/* Set cookie */
					if ( content.data.config.settings_cookie != undefined ) {
						setCookie( content.data.config.settings_cookie, JSON.stringify(cookie_settings), settings_lifetime )
					}
				}
			}

			/* Remove classes */
			ev.target.classList.remove( 'loading' )
			checkCookieButtons()
		})
		.catch((error) => {
			/* Remove classes */
			ev.target.classList.remove( 'loading' )

			console.log(error)
		})
	})
	document.querySelector( 'a[href="#deny-cookie"]' )?.addEventListener( 'click', (ev) => {
		/* Prevent */
		ev.preventDefault()

		/* Add classes */
		ev.target.classList.add( 'loading' )

		/* Setup */
		let params = {
				action: 'liquidgumbo_load_cookies',
				_ajax_nonce: liquidgumbo.security,
				cookie_name: ev.target.closest( '.cookie-item' ).getAttribute('data-cookie-name')
			},
			options = {
				body: params
			},
			cookie_settings = JSON.parse( getCookie( liquidgumbo_cookies.settings_cookie ) ),
			settings_lifetime = '1y'

		/* Set last date */
		cookie_settings['last_change'] = new Date().getTime()

		/* Delete cookie settings cookie */
		ajax.post(
			liquidgumbo.ajaxurl,
			options
		).then((content) => {
			/* Check for cookies */
			if ( content.success == true ) {
				/* Check for cookies */
				if ( content.data.cookies ) {
					/* Switch type */
					for ( let key in content.data.cookies ) {
						if (content.data.cookies.hasOwnProperty( key ) ) {
							let cookie = content.data.cookies[key],
								lifetime = formatLifetime( cookie )

							/* Add cookie to cookie settings info - only for non-settings cookies */
							if ( cookie.cookiecategory != undefined ) {
								/* Add key as category to prevent name change problems */
								if ( cookie_settings[ cookie.cookiecategory.ID ] == undefined ) {
									cookie_settings[ cookie.cookiecategory.ID ] = {}
								}
								
								/* Check for deniable cookies */
								if ( cookie.cookiecategory.deniable == 1 ) {
									cookie_settings[ cookie.cookiecategory.ID ][ cookie.cookie_name ] = false
									deleteCookie( cookie.cookie_name )
								} else {
									cookie_settings[ cookie.cookiecategory.ID ][ cookie.cookie_name ] = true
								}
							} else {
								/* Add to undefined */
								if ( cookie_settings[ 'undefined' ] == undefined ) {
									cookie_settings[ 'undefined' ] = {}
								}
								cookie_settings[ 'undefined' ][ cookie.cookie_name ] = false
								deleteCookie( cookie.cookie_name )
							}
							if ( cookie.cookie_name == content.data.config.settings_cookie ) {
								/* Safe settings lifetime */
								settings_lifetime = lifetime
							}
						}
					}

					/* Set cookie */
					if ( content.data.config.settings_cookie != undefined ) {
						setCookie( content.data.config.settings_cookie, JSON.stringify( cookie_settings ), settings_lifetime )
					}
				}
			}

			/* Remove classes */
			ev.target.classList.remove( 'loading' )
			checkCookieButtons()
		})
		.catch((error) => {
			/* Remove classes */
			ev.target.classList.remove( 'loading' )

			console.log(error)
		})
	})

	function activateCookie( cookie, lifetime ) {
		/* Check if cookie needs to be activated */
		if ( cookie.set_when_active && getCookie( cookie.cookie_name ) == null ) {
			/* Check for value */
			switch ( cookie.cookie_content ) {
				case 'unique_id':
					setCookie( cookie.cookie_name, generate_guid(), lifetime )
				break;

				case 'true_false':
					setCookie( cookie.cookie_name, true, lifetime )
					break;
					
				default:
					setCookie( cookie.cookie_name, true, lifetime )
				break;
			}
		}
	}

	function formatLifetime( cookie ) {
		/* Check lifetime */
		if ( cookie.lifetime != undefined ) {
			switch (cookie.lifetime) {
				case '1_year':
					return '1y'
				break;
	
				case '1_day':
					return '1d'
				break;
	
				case '2_days':
					return '2d'
				break;
				
				case '14_days':
					return '14d'
				break;
	
				case 'active_session':
					return 'session'
				break;
			}
		}

		/* Return */
		return 'session'
	}

	function checkCookieButtons() {
		/* Get cookie settings */
		cookie_settings = getCookie( liquidgumbo_cookies.settings_cookie )

		if (cookie_settings != null) {
			cookie_settings = JSON.parse(cookie_settings)
		}

		/* Check for existing cookie */
		if ( cookie_settings != null ) {
			/* Cookie settings were saved before - close the banner */
			document.querySelectorAll( '.liquidgumbo-cookiebanner' )?.forEach((elem) => {
				elem.classList.add( 'is-closed' )
			})
			
			/* Cookie settings were saved before - close the banner */
			document.querySelectorAll( '.liquidgumbo-cookie-list .cookie-item' )?.forEach((cookie) => {
				/* Check if cookie can be allowed/denied in general */
				if ( cookie.querySelectorAll( '.actions a.button' ).length > 0 ) {
					let category_ref = cookie.getAttribute('data-cookie-category-ref'),
						cookie_name = cookie.getAttribute('data-cookie-name')
					
					if ( 
						cookie_settings[category_ref][cookie_name] == undefined || 
						cookie_settings[category_ref][cookie_name] == false
					) {
						/* Cookie is not set - hide deny button */
						cookie.querySelector( 'a[href="#deny-cookie"]')?.classList.add( 'is-hidden' )
						cookie.querySelector( 'a[href="#allow-cookie"]')?.classList.remove( 'is-hidden' )
					} else {
						/* Cookie is active - hide allow button */
						cookie.querySelector( 'a[href="#allow-cookie"]')?.classList.add( 'is-hidden' )
						cookie.querySelector( 'a[href="#deny-cookie"]')?.classList.remove( 'is-hidden' )
					}
				}
			})
		} else {
			/* Cookie settings were not saved before - show the banner */
			document.querySelectorAll( '.liquidgumbo-cookiebanner' )?.forEach((elem) => {
				elem.classList.remove( 'is-closed' )
			})

			/* Hide all deny butons */
			if ( document.querySelectorAll( '.cookie-item .actions a.button').length > 0 ) {
				/* Cookie is not set - hide deny button */
				document.querySelectorAll( 'a[href="#allow-cookie"]')?.forEach((elem) => {
					elem.classList.remove( 'is-hidden' )
				})
				document.querySelectorAll( 'a[href="#deny-cookie"]')?.forEach((elem) => {
					elem.classList.add( 'is-hidden' )
				})
			}
		}
	}
})()
